export const API_BASE_URL = "https://api.itengo.pro/api/"
// export const API_BASE_URL = "http://192.168.1.21:8080/api/"

export const LOGIN_ENDPOINT = `${API_BASE_URL}public/auth/login`;
// export const notify = `${API_BASE_URL}public/notify/notifications`;
export const notify = `${API_BASE_URL}protected/notifications/pending`;
export const courtAdd = `${API_BASE_URL}private/court/create-or-update`;
export const courtFetch = `${API_BASE_URL}private/court/fetch`;
export const disableCourt = `${API_BASE_URL}private/disable-court`
export const sportAdd = `${API_BASE_URL}private/sports/create-or-update`;
export const fetchSports = `${API_BASE_URL}private/sports/fetch`;
export const fetchUsersList = `${API_BASE_URL}private/fetch-users`;
export const deactivateUsers = `${API_BASE_URL}private/deactivate-user`;
export const reactivateUsers = `${API_BASE_URL}private/reactivate-user`;
export const forgotPassword = `${API_BASE_URL}public/auth/forget-password`;
export const changePassword = `${API_BASE_URL}private/change-password`;
export const resetPassword = `${API_BASE_URL}public/auth/reset`;
export const getPlans = `${API_BASE_URL}private/plans`;
export const createOrUpdatePlan = `${API_BASE_URL}private/create-or-update-plan`;
export const fetchTransactions = `${API_BASE_URL}private/transaction-details`;
export const fetchRevenue = `${API_BASE_URL}private/revenue-report`;
export const fetchCms = `${API_BASE_URL}private/fetch-images`;
export const uploadCms = `${API_BASE_URL}public/file-upload`;
export const uploadCsv = `${API_BASE_URL}private/file-upload`;
export const updateCms = `${API_BASE_URL}private/create-edit-image`;
export const deleteCms = `${API_BASE_URL}private/delete-image`;
export const fetchUserGrowth = `${API_BASE_URL}private/user-growth`;
export const fetchRevenueGrowth = `${API_BASE_URL}private/revenue-growth`;
export const fetchRevenueByPlan = `${API_BASE_URL}private/revenue-by-plan`;
export const fetchPopularCourts = `${API_BASE_URL}private/popular-court`;
export const fetchApiServices = `${API_BASE_URL}private/get-services`;
export const addNewApiService = `${API_BASE_URL}private/add-service`;
export const fetchPushNotifications = `${API_BASE_URL}private/past-notifications`;
export const createPushNotification = `${API_BASE_URL}private/create-update-notification`;
export const deletePushNotification = `${API_BASE_URL}private/delete-notification`;
export const fetchConfiguration = `${API_BASE_URL}private/fetch-configurations`;
export const updateConfiguration = `${API_BASE_URL}private/configurable`;
export const fetchGames = `${API_BASE_URL}private/all-games`;
export const refund = `${API_BASE_URL}private/refund`
export const togglePlanStatus = `${API_BASE_URL}private/toggle-plan`
export const fetchAdminNotifications = `${API_BASE_URL}protected/notifications/pending`
export const markAsRead = `${API_BASE_URL}protected/notifications/mark-seen`
export const fetchReports = `${API_BASE_URL}private/reports`
export const fetchIndividualReport = `${API_BASE_URL}private/report-details?reportId=`
export const reportTakeAction = `${API_BASE_URL}private/take-action`

// export const WEBSOCKET_CONNECTION = `${API_BASE_URL}public/ws`;

// export const MESSAGE_TYPES = {
//     PRIVATE: "private",
//     GROUP: "group",
//     SEEN: "seen"
// };